<mat-toolbar  color="primary" class="mat-elevation-z4">
    <div class="legend-toolbar">
        <span>Adjust Legend</span>
        <div class="separator"></div>
        <div class="rectangle removed"></div>
        <div>Image sets excluded</div>
        <div class="rectangle extra"></div>
        <div>Extra image Sets</div>
        <div class="rectangle moved"></div>
        <div>Image sets moved</div>
    </div>
</mat-toolbar>
<div class="controls-container">
    <mat-form-field appearance="fill">
        <mat-label>Select Round</mat-label>
        <mat-select [(ngModel)]="selectedRound" name="selectedRound" (selectionChange)="onRoundChange($event)">
        <mat-option *ngFor="let round of rounds" [value]="round">
            {{ round == 0 ? 'All Rounds' : round }}
        </mat-option>
        </mat-select>
    </mat-form-field>
</div>
<div class="legend-list-container">
    <div class="table-container">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

            <!-- LegendId Column -->
            <ng-container matColumnDef="legendDataId">
                <th mat-header-cell *matHeaderCellDef sticky>LegendId</th>
                <td mat-cell *matCellDef="let element">{{ element.legendId }}</td>
            </ng-container>

            <!-- LegendName Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef sticky>LegendName</th>
                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
            </ng-container>

            <!-- Add To Sequence Column -->
            <ng-container matColumnDef="cassettes">
            <th mat-header-cell *matHeaderCellDef sticky>Cassettes</th>
            <td mat-cell *matCellDef="let element; let rowIndex = index">
                <div class="results-container"
                    cdkDropList
                    #dropListRef="cdkDropList"
                    [cdkDropListData]="element.cassettes"
                    [cdkDropListConnectedTo]="connectedDropLists"
                    (cdkDropListDropped)="onDrop($event, rowIndex)">

                    <ng-container *ngFor="let r of element.cassettes">
                        <div class="result" *ngIf="r.show"
                            cdkDrag
                            [cdkDragData]="r"
                            [cdkDragDisabled]="!(currentRoles | hasAnyICRoles : ['ICWRITER'] : experiment : 'IsAnyStatus') || !(icRoundService.getLastRound() == r.roundNumber) || ((icRoundService.getLastRound() == r.roundNumber) && (experiment | icstatusIs : ['AnalyzingImages','Complete']))"
                            [ngClass]="{ 'extra': r.isExtra, 'removed': r.isExcluded, 'moved': r.isMoved }">
                            
                            <span>{{ removeFirstVersion(r.casseteNumber) }}</span>

                            <button mat-icon-button (click)="showImages(r)" class="icon-small">
                                <mat-icon >image</mat-icon>
                            </button>

                            <app-note-display
                                [experimentId]="experimentId"
                                [noteCount]="0"
                                [hasLiveNote]="r.hasLiveNote"
                                [objectID]="encodeCassetteId(r.casseteNumber)"
                                [objectName]="'Cassette'"
                                [isDisabled]="!(currentRoles | hasAnyICRoles : ['ICWRITER'] : experiment : 'IsAnyStatus')">
                            </app-note-display>
                            
                            <button mat-icon-button class="icon-small" *ngIf="r.isExcluded && (currentRoles | hasAnyICRoles : ['ICWRITER'] : experiment : 'IsAnyStatus')" (click)="add(r)"
                                [disabled]="!(icRoundService.getLastRound() == r.roundNumber) || ((icRoundService.getLastRound() == r.roundNumber) && (experiment | icstatusIs : ['AnalyzingImages','Complete']))">
                                <mat-icon style="color: green;">add_circle</mat-icon>
                            </button>

                            <button mat-icon-button class="icon-small" *ngIf="!r.isExcluded && (currentRoles | hasAnyICRoles : ['ICWRITER'] : experiment : 'IsAnyStatus')" (click)="remove(r)"
                                [disabled]="!(icRoundService.getLastRound() == r.roundNumber) || ((icRoundService.getLastRound() == r.roundNumber) && (experiment | icstatusIs : ['AnalyzingImages','Complete']))">
                                <mat-icon style="color: red;">cancel</mat-icon>
                            </button>
                        </div>
                    </ng-container>
                </div>
            </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>
<div class="actions">
    <button mat-raised-button (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="!(currentRoles | hasAnyICRoles : ['ICWRITER'] : experiment : 'IsAnyStatus')">Save</button>
</div>